import { DICT_USER, EDIT_CARD, REQUEST_EDIT_CARD, VIEW_CARD } from '@/common/rights.js';
import { hasAnyDictRight } from '@/common/session.js';
import { isMobile } from '@/common/util/util.js';

export default [
    {
        path: '/',
        name: 'home',
        alias: '/home',
        component: () => import('./pages/home/Home.vue'),
        meta: {
            rights: [ VIEW_CARD ],
            layout: () => isMobile() ? 'Nothing' : 'Default',
            hideHeader: true,
            title: 'Главная',
        },
    },
    {
        name: 'product',
        path: '/product/:id',
        component: () => import('@/pages/product/card/ProductCard.vue'),
        meta: {
            rights: [ VIEW_CARD ],
            layout: () => isMobile() ? 'Nothing' : 'Default',
            title: 'Карточка продукта',
        },
    },
    {
        path: '/admin',
        name: 'admin',
        component: () => import('./pages/admin/Admin.vue'),
        meta: {
            rights: hasAnyDictRight,
            layout: 'Default',
            title: 'Администрирование',
        },
    },
    {
        path: '/admin/create-background',
        name: 'create-background',
        component: () => import('./pages/admin/create_background/CreateBackground.vue'),
        meta: {
            rights: [ DICT_USER ],
            layout: 'Default',
            noMetric: true,
            title: 'Администрирование - Добавление обложки карточки',
        },
    },
    {
        path: '/drafts',
        name: 'drafts',
        component: () => import('./pages/drafts/Drafts.vue'),
        meta: {
            rights: [ EDIT_CARD, REQUEST_EDIT_CARD ],
            layout: 'Default',
            noMetric: true,
            title: 'Черновики',
        },
    },
    {
        path: '/about-site/',
        name: 'about-site',
        component: () => import('./pages/about_site/AboutSite.vue'),
        meta: {
            rights: [ VIEW_CARD ],
            layout: 'Default',
            title: 'О портале',
        },
        children: [
            {
                path: 'user-guides',
                name: 'user-guides',
                component: () => import('./pages/about_site/user_guide/UserGuides.vue'),
                meta: {
                    rights: [ VIEW_CARD ],
                    layout: 'Default',
                    title: 'Руководства пользователя - О портале',
                },
            },
            {
                path: 'courses',
                name: 'courses',
                component: () => import('./pages/about_site/course/Courses.vue'),
                meta: {
                    rights: [ VIEW_CARD ],
                    layout: 'Default',
                    title: 'Курсы - О портале',
                },
            },
        ],
        redirect: { name: 'user-guides' },
    },
];
